<procure-card class="page-maintenance-mode">
  <div formRow>
    <p class="page-maintenance-mode__text">
      The current page has been locked for maintenance. Please contact your direct supervisor for additional
      information.
    </p>
  </div>
  @if (maintenanceText) {
    <div formRow>
      <p class="page-maintenance-mode__text">
        {{ maintenanceText }}
      </p>
    </div>
  }
  <div class="page-maintenance-mode__actions">
    <button
      class="page-maintenance-mode__button"
      procure-button
      [routerLink]="redirectUrl"
    >
      {{ redirectLabel }}
    </button>
  </div>
</procure-card>
